import { render, staticRenderFns } from "./wages.vue?vue&type=template&id=ae142316&scoped=true"
import script from "./wages.vue?vue&type=script&lang=js"
export * from "./wages.vue?vue&type=script&lang=js"
import style0 from "./wages.vue?vue&type=style&index=0&id=ae142316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae142316",
  null
  
)

export default component.exports